import script from "./ProductDataMixin.vue?vue&type=script&lang=js"
export * from "./ProductDataMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__